var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6485 4.35C14.1976 2.9 12.2064 2 9.995 2C5.57223 2 2 5.58 2 10C2 14.42 5.57223 18 9.995 18C13.7273 18 16.8393 15.45 17.7298 12H15.6485C14.828 14.33 12.6066 16 9.995 16C6.68293 16 3.99124 13.31 3.99124 10C3.99124 6.69 6.68293 4 9.995 4C11.656 4 13.137 4.69 14.2176 5.78L10.9956 9H18V2L15.6485 4.35Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReload);
export default __webpack_public_path__ + "static/media/icon-reload.56c1e146be4e3100a5ee35bd3b311693.svg";
export { ForwardRef as ReactComponent };